import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yi-single',
  template: require('./single.component.html'),
  styles: [require('./single.component.scss')]
})
export class SingleComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {

  }

}
